import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabserviceinmumbai() {



const cardData = {
  keyword: " Cab Service in Mumbai",

headingDescription:
  "Omshree Cab provides reliable and comfortable cab services in Mumbai for travelers seeking convenient and hassle-free transportation within the city. Whether you need a cab for airport transfers, business meetings, city sightseeing, family outings, or group travel, our service ensures a smooth and safe ride with professional drivers and well-maintained vehicles. We offer flexible booking options including one-way trips, round trips, hourly rentals, and full-day packages at transparent per-kilometer and hourly pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With experienced chauffeurs skilled in navigating city traffic, punctual pickups from any location in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for dependable Mumbai cab services.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic landmarks, attracting tourists from all over the world. Visitors can admire the architecture, take boat rides to Elephanta Caves, and enjoy the vibrant surroundings. Using a cab service ensures hassle-free travel, allowing enough time to explore the area without worrying about parking or local transport."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive, also known as the Queen’s Necklace, is a scenic promenade along the Arabian Sea. Visitors can enjoy sunset views, leisurely walks, and photography. Traveling by cab provides comfortable access and the flexibility to stop at viewpoints along the 3.6 km stretch without traffic stress."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    description:
      "CSMT is a UNESCO World Heritage Site and a historic railway station in Mumbai, renowned for its Victorian Gothic architecture. Visitors can explore the station, take photographs, and admire its historical significance. A cab ride ensures convenient travel to and from the station while navigating Mumbai city traffic."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street famous for street shopping, cafes, and local culture. Visitors can shop for clothing, handicrafts, souvenirs, and enjoy local snacks. Using a cab service ensures safe and comfortable travel, making it easy to combine shopping with sightseeing across Mumbai."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most revered temples in Mumbai, attracting devotees and tourists alike. Visitors can perform rituals, experience spiritual ambiance, and enjoy architectural beauty. A cab service provides hassle-free access and convenient timing for spiritual visits in the busy city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and tomb located on a small islet off the coast of Mumbai. Visitors can enjoy scenic views, religious rituals, and photography. Traveling by cab ensures easy access and allows visitors to plan their trip efficiently while avoiding long walks through crowded areas."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is a popular destination for leisure, street food, and sunset views. Visitors can enjoy camel rides, local snacks, and the vibrant atmosphere. A cab ride provides convenient transport, ensuring travelers can explore the beach and nearby attractions comfortably."
  },
  {
    title: "Chor Bazaar",
    description:
      "Chor Bazaar is one of Mumbai’s oldest and most famous flea markets, known for antiques, vintage items, and quirky collectibles. Visitors can shop, explore local culture, and enjoy photography. Using a cab service ensures safe travel to and from the market, making it easier to combine with other city sightseeing spots."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are terraced gardens offering panoramic views of Marine Drive and lush greenery. Visitors can relax, take photographs, and enjoy the cool breeze. Traveling by cab allows convenient access and flexibility to include multiple attractions in a day."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves, located on Elephanta Island, are famous for rock-cut sculptures and ancient Hindu and Buddhist carvings. Visitors can explore the caves, enjoy boat rides, and capture photographs. A cab service ensures hassle-free transport to the Gateway of India, from where ferries depart to the island, making sightseeing seamless."
  }
],




services: [
{
name: "Cab Service in Mumbai",
description: "Cab service in Mumbai offers reliable and comfortable transportation for local and outstation travel across the city. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for business, tourism, and personal trips. Professional drivers ensure safe driving and timely arrival at your destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for daily travel, airport transfers, and corporate trips. Spacious seating and air-conditioned interiors ensure relaxed journeys. Flexible booking options allow easy ride scheduling anytime. Transparent pricing ensures a smooth and dependable cab experience in Mumbai."
},
{
name: "Taxi Service in Mumbai",
description: "Taxi service in Mumbai provides convenient transportation for passengers traveling within the city and nearby destinations. Comfortable AC vehicles ensure pleasant travel through busy city roads and highways. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available across Mumbai including residential areas, offices, hotels, and airports. Ideal for local travel, business meetings, and sightseeing. Clean interiors and spacious seating provide comfortable journeys. Flexible travel scheduling allows passengers to book rides anytime. Reliable taxi services ensure safe and smooth travel."
},
{
name: "Mumbai Cab Service",
description: "Mumbai cab service offers dependable road transportation for residents and visitors traveling across the city. Our well-maintained fleet includes sedans, SUVs, and luxury vehicles suitable for all travel needs. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, and transport hubs across Mumbai. Ideal for airport transfers, local trips, and outstation travel. Spacious interiors ensure comfortable seating for passengers. Flexible booking options allow travelers to schedule rides easily. Transparent pricing ensures reliable cab service."
},
{
name: "Best Cab Service Mumbai",
description: "Best cab service in Mumbai provides high-quality transportation solutions for comfortable city travel. Our fleet includes modern AC vehicles designed for smooth and safe journeys. Professional drivers offer courteous service and reliable driving experience. Pickup services are available across Mumbai including airports, railway stations, and hotels. Ideal for business travelers, tourists, and families. Spacious seating ensures passenger comfort during travel. Flexible booking options allow quick ride scheduling. Reliable cab service ensures a premium travel experience."
},
{
name: "Cheap Cab Service Mumbai",
description: "Cheap cab service in Mumbai offers affordable transportation without compromising comfort and safety. Budget-friendly AC sedans and compact cars ensure economical city travel. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, offices, hotels, and transportation hubs across Mumbai. Ideal for daily commuters, students, and budget travelers. Comfortable seating ensures relaxed travel within the city. Flexible ride booking options allow convenient travel planning. Transparent fares ensure affordable cab travel."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai taxi service offers dependable city transportation for passengers traveling across the metropolitan area. Comfortable AC vehicles ensure pleasant travel throughout the journey. Experienced drivers ensure safe navigation through busy city routes. Pickup services are available across Mumbai including homes, offices, hotels, and airports. Ideal for daily commuting, airport transfers, and tourism travel. Clean interiors and spacious seating ensure comfortable rides. Flexible booking options allow passengers to schedule trips easily. Reliable taxi services ensure smooth transportation."
},
{
name: "Local Cab Service Mumbai",
description: "Local cab service in Mumbai provides convenient travel for passengers moving within city limits. Our AC vehicles ensure comfortable travel through busy roads and traffic areas. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, offices, hotels, and commercial areas across Mumbai. Ideal for office travel, shopping trips, and personal visits. Spacious seating ensures comfortable short-distance journeys. Flexible booking options allow easy ride scheduling. Reliable cab services ensure stress-free local travel."
},
{
name: "Outstation Cab Service Mumbai",
description: "Outstation cab service in Mumbai offers reliable transportation for travelers planning trips outside the city. Our fleet includes sedans, SUVs, and luxury vehicles suitable for long-distance highway travel. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available across Mumbai including homes, hotels, and airports. Ideal for weekend trips, family vacations, and corporate travel. Spacious seating ensures comfort during long journeys. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures dependable outstation cab service."
},
{
name: "Airport Cab Service Mumbai",
description: "Airport cab service in Mumbai offers reliable transportation for travelers arriving or departing from Mumbai Airport. Comfortable AC vehicles ensure smooth travel between the airport and city destinations. Professional drivers monitor flight timings to provide punctual pickup and drop services. Pickup is available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for business travelers, tourists, and family travel. Spacious seating ensures comfort during airport transfers. Flexible booking options allow quick ride scheduling. Reliable airport cab service ensures stress-free travel."
},
{
name: "Mumbai Cab Booking Online",
description: "Mumbai cab booking online allows passengers to reserve vehicles easily using quick digital booking systems. Instant confirmation ensures convenient ride scheduling for city travel. Comfortable AC sedans and SUVs provide smooth transportation across Mumbai. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential and commercial areas. Ideal for business travel, tourism, and daily commuting. Flexible booking options allow easy ride management. Reliable online booking ensures hassle-free cab travel."
},
{
name: "Mumbai Taxi Booking Online",
description: "Mumbai taxi booking online provides fast and convenient reservations for passengers planning local or outstation travel. Instant booking confirmation allows travelers to schedule rides easily. Comfortable AC vehicles ensure relaxed travel across the city. Experienced drivers ensure safe and professional driving services. Pickup services are available across Mumbai including homes, hotels, offices, and airports. Ideal for tourists, business travelers, and families. Flexible scheduling options allow convenient ride planning. Reliable online taxi booking ensures smooth travel."
},
{
name: "Mumbai Cab Price",
description: "Mumbai cab price offers transparent and affordable travel options for passengers planning city transportation. Clear pricing helps travelers understand the total trip cost before booking. Our fleet includes sedans, SUVs, and luxury vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe city driving and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible ride options allow passengers to choose local or outstation trips. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai Taxi Charges",
description: "Mumbai taxi charges are calculated with transparent pricing to provide clear travel costs for passengers. Different vehicle options allow travelers to choose according to comfort and budget preferences. Our AC vehicles ensure smooth travel across the city and highways. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for local travel and outstation trips. Flexible booking options allow easy ride scheduling. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "24x7 Cab Service Mumbai",
description: "24x7 cab service in Mumbai offers round-the-clock transportation for passengers traveling anytime. Our AC vehicles ensure comfortable travel during day and night journeys. Professional drivers provide safe driving and punctual pickup services at all hours. Pickup services are available across Mumbai including residential areas, offices, and airports. Ideal for late-night airport transfers, emergency travel, and corporate needs. Spacious seating ensures comfortable journeys. Flexible booking options allow instant ride scheduling. Reliable cab service ensures safe 24-hour transportation."
},
{
name: "Reliable Cab Service Mumbai",
description: "Reliable cab service in Mumbai offers dependable transportation for passengers traveling across the city. Our fleet includes well-maintained AC vehicles ensuring smooth and comfortable journeys. Professional drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for business travel, tourism trips, and daily commuting. Spacious seating ensures passenger comfort throughout the journey. Flexible booking options allow easy ride scheduling. Trusted cab services ensure reliable city transportation."
},
{
name: "Corporate Cab Service Mumbai",
description: "Corporate cab service in Mumbai offers professional transportation solutions for businesses and corporate travelers. Our fleet includes executive sedans and premium SUVs suitable for office travel and business meetings. Professional drivers provide punctual pickup and professional service. Pickup services are available across Mumbai including offices, hotels, and airports. Ideal for corporate transfers, employee travel, and client visits. Comfortable interiors ensure relaxed travel for executives. Flexible booking options allow scheduled corporate rides. Reliable corporate cab service ensures efficient business transportation."
},
{
name: "Luxury Cab Service Mumbai",
description: "Luxury cab service in Mumbai offers premium transportation for passengers seeking high-end travel comfort. Our fleet includes luxury sedans and SUVs designed for superior travel experiences. Professional chauffeurs ensure smooth driving and courteous service. Pickup services are available across Mumbai including hotels, airports, and business centers. Ideal for VIP travel, corporate executives, and special occasions. Spacious interiors and premium seating ensure ultimate comfort. Flexible booking options allow convenient ride scheduling. Luxury cab service ensures a stylish and comfortable journey."
}
],

tableData: [
["Cab Service in Mumbai","Taxi Service in Mumbai"],
["Mumbai Cab Service","Best Cab Service Mumbai"],
["Cheap Cab Service Mumbai","Mumbai Taxi Service"],
["Local Cab Service Mumbai","Outstation Cab Service Mumbai"],
["Airport Cab Service Mumbai","Mumbai Cab Booking Online"],
["Mumbai Taxi Booking Online","Mumbai Cab Price"],
["Mumbai Taxi Charges","24x7 Cab Service Mumbai"],
["Reliable Cab Service Mumbai","Corporate Cab Service Mumbai"],
["Luxury Cab Service Mumbai","Best Taxi Service Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Local Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with Mumbai’s busy roads, traffic patterns, and shortcuts. Whether you are traveling within the city or heading for an outstation trip, they ensure a safe and smooth ride."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for cab services in Mumbai. We clearly explain per-kilometer rates, toll charges, and travel packages before booking so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Mumbai is a city that never sleeps, and our cab service operates 24/7. Whether you need an early morning airport drop or a late-night ride, Omshree Cabs is always available."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable ride for both short city trips and long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including local hourly packages, airport transfers, outstation cabs, and corporate travel services to meet different customer needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for solo travelers, families, and business travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai so your journey begins smoothly without travel stress."
  },
  {
    WhyChooseheading: "Reliable & Professional Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable cab services in Mumbai. Our punctual drivers, comfortable vehicles, and professional customer support ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide cab service anywhere in Mumbai?", answer: "Yes, Omshree Cabs provides cab services across all areas of Mumbai including South Mumbai, Western Suburbs, Eastern Suburbs, and Navi Mumbai." },
  { question: "Can I book a cab for airport transfer?", answer: "Yes, we provide airport pickup and drop services to and from Mumbai Airport terminals." },
  { question: "Do you offer outstation cab services from Mumbai?", answer: "Yes, Omshree Cabs provides outstation travel to destinations like Pune, Lonavala, Nashik, Surat, and many more." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on customer preference and group size." },
  { question: "Is cab service available 24 hours?", answer: "Yes, Omshree Cabs operates 24/7 for local, airport, and outstation travel in Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide corporate cab services?", answer: "Yes, we offer corporate travel solutions for business meetings, employee transport, and airport transfers." },
  { question: "Can I book a cab online?", answer: "Yes, you can easily book a cab online or through phone for instant confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak hours, weekends, and festivals." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "I regularly use Omshree Cabs for local travel in Mumbai. The drivers are punctual and the cars are always clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback:
      "Booked Omshree Cabs for airport transfer and the service was excellent. On-time pickup and smooth ride made the journey stress-free.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Mumbai",
  "description": "Omshree Cab offers the best cab service in Mumbai with 24x7 availability. Book taxis for local travel, airport transfers, outstation trips, corporate travel, and luxury rides. Affordable fares, easy online booking, and reliable service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5000"
  }
};




  return (
    <div>
      


<Helmet>
  <title>Cab Service in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides reliable cab service in Mumbai. Book taxis for local travel, airport transfers, outstation trips, corporate and luxury rides. Affordable fares and easy online booking for all Mumbai cab services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmumbai;